// extracted by mini-css-extract-plugin
export default {"checkbox":"Gf95d06","label":"G0789f5 Ge99fa0 G9245dd G81a5ae"};